module.exports = __webpack_public_path__ + "img/team-member-4.36e406d2.png";